export default __webpack_public_path__ + "static/media/yield.8f44ae61.png";